import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ModalHeaderTitle from "layouts/users/AddEditUserModal/Header";
import { NewNotification, Notification } from "types/Notification";
import { Formik, Form as FormikForm } from "formik";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { StyledEngineProvider } from "@mui/material/styles";

type AddViewModalProp = {
  open: boolean;
  handleClose: () => void;
  isView: boolean;
  selectedRow?: Notification;
  createNewNotification: (notifcation: NewNotification) => void;
};
const initialValues = {
  title: "",
  body: ""
};
const AddViewNotificationsModal: React.FC<AddViewModalProp> = (props) => {
  const { open, handleClose, isView, selectedRow, createNewNotification } =
    props;
  const formikRef = useRef<any>(null);

  const handleOnClose = (_: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      console.info("Backdrop is clicked");
    } else {
      handleClose();
    }
  };

  const onSubmit = (values) => {
    const { title, body } = values;

    const request: NewNotification = {
      title,
      body
    };
    if (
      window.confirm(
        `Are you sure you want to create this notification? This action will be sent to all your customers.`
      ) === true
    ) {
      try {
        createNewNotification(request);
      } catch (e: any) {
        alert(e.error ?? e);
      }
    }
  };

  return (
    <StyledEngineProvider injectFirst>
      <Dialog
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableEscapeKeyDown={true}
        onBackdropClick={(event) => {
          event.stopPropagation();
          return false;
        }}
      >
        <ModalHeaderTitle id="customized-dialog-title" onClose={handleClose}>
          {`${isView ? "View" : "New"} Notification`}
        </ModalHeaderTitle>{" "}
        <DialogContent dividers>
          <Formik
            initialValues={
              isView && !!selectedRow ? selectedRow : initialValues
            }
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <MDBox mb={2} ml={1} display={"flex"}>
                  <MDBox mr={5} width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Title"
                      name="title"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                    />
                  </MDBox>
                  <MDBox width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Sub Title"
                      name="body"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.body}
                    />
                  </MDBox>
                </MDBox>
              </FormikForm>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              //Trigger formik button as outside the form
              if (formikRef.current) {
                formikRef.current.handleSubmit();
              }
            }}
          >
            {`${isView ? "Resend" : "Create"}`}
          </Button>
        </DialogActions>
      </Dialog>
    </StyledEngineProvider>
  );
};
export default AddViewNotificationsModal;
